
import { fetchCurrentPrices, fetchPriceHistory } from '@/lib/metal-price';

/**
 * Fetches current prices for gold and silver
 */
export const fetchMetalPrices = async () => {
  return await fetchCurrentPrices();
};

/**
 * Fetches price history for a specific period
 */
export const fetchMetalPriceHistory = async (period: any) => {
  return await fetchPriceHistory(period);
};
